<script>
	import { ArchiveIcon, EyeIcon } from "svelte-feather-icons"
	export let device
</script>

{#if device}
	{#if device.state === "DECOMMISSIONED"}
		<div class='decom'><ArchiveIcon /></div>
	{:else if device.radioType === "LTE" }
		{#if device.state !== 'DISCONNECTED'}
			<img src="/images/Active LTE.png" class="ars" alt="ARS" />
		{:else}
			<img src="/images/lte-gray.png" class="ars" alt="ARS" />
		{/if}
	{:else if device.type === "ARS"}
		<img src="/images/ars-gray.png" class="ars" alt="ARS" />
	{:else if device.type === "SRS"}
		<div class='srs' class:active={device && device.state === "ACTIVE"}><EyeIcon size='18' /></div>
	{:else}
		<img src="/images/grs-inactive.png" class="grs" class:active={device && device.state !== "DISCONNECTED"} alt="GRS" />
	{/if}
{/if}

<style>


	img {
		height: 30px;
		margin-right:4px
	}
	img.grs {
		padding: 4px;
		padding-top: 6px;
	}
	img.grs.active {
		background: rgb(2 154 1);
		background: radial-gradient(circle, rgb(2 154 1) 0%, rgba(20,255,0,0) 65%)
	}

	.decom {
		padding:4px;
		height:30px;
		margin:0 auto;
		text-align:center;
	}

	.srs {
		padding:4px;
		border-radius: 50%;
		border:1px solid black;
		height: 28px;
		width: 28px;
		margin: 2px;
	}

	.srs :global(svg) {
		width:18px;
	}

	.srs.active {
		background-color: cornflowerblue;
	}
</style>